import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAsObservableSource } from 'mobx-react-lite';
import {
    CheckIconWrapper,
    CheckboxContainer,
    CheckboxWrapper,
} from './SimpleCheckbox.style';

export interface PropsType {
    isChecked: boolean,
    isDisabled: boolean,
    onChange: () => void
}

export const SimpleCheckbox = observer('SimpleCheckbox', (propsIn: PropsType): JSX.Element => {
    const props = useAsObservableSource(propsIn);
    const { isChecked, isDisabled, onChange } = props;

    return (
        <CheckboxContainer>
            <CheckboxWrapper
                onClick={onChange}
                isChecked={isChecked}
                isDisabled={isDisabled}
            >
                { isChecked ? <CheckIconWrapper isChecked={isChecked} /> : null }
            </CheckboxWrapper>
        </CheckboxContainer>
    );
});
